module.exports = __webpack_public_path__ + "img/jcb.a86c6701.svg";